// STUN/TURN serveri dolaze sa servera (kredencijali nisu u kodu klijenta)
const FALLBACK = [{ urls: 'stun:stun.l.google.com:19302' }];
const CACHE_MS = 5 * 60 * 1000;
let cache = { servers: null, at: 0 };

export async function getIceServers(socket) {
  if (cache.servers && Date.now() - cache.at < CACHE_MS) return cache.servers;
  try {
    const res = await socket.timeout(5000).emitWithAck('ice:get', {});
    if (res && Array.isArray(res.iceServers) && res.iceServers.length) {
      cache = { servers: res.iceServers, at: Date.now() };
      return res.iceServers;
    }
  } catch (e) {
    console.warn('[ICE] Server nije vratio ICE listu, koristim samo STUN:', e.message);
  }
  return FALLBACK;
}
